import { Routes } from '~/api/api-routes'
import axios from '~/api/axiosBase'

const collectionsCache = {}

export const fetchTiktokWarehouses = async () => {
  return (await axios.get(Routes.tiktok.fetchWarehouses())).data.data
}

export const patchTiktokWarehouse = async (data) => {
  const url = Routes.tiktok.patchWarehouse(data)
  return await axios.patch(url)
}

export const checkShippingTemplate = async () => {
  return await axios.post(Routes.myStores.checkShippingTemplate)
}

export const confirmImportWarning = async (key) => {
  return await axios.post(Routes.common.config, [
    {
      key,
      context: {
        value: true,
      },
    },
  ])
}

export const checkImportWarning = async () => {
  return (await axios.get(`${Routes.common.config}?keys=importWarning,availableWarning`)).data?.data
}

export const fetchSuggestedCollections = async (productName) => {
  const url = `${Routes.tiktok.fetchSuggestedCollections()}?product_title=${productName}`
  return (await axios.get(url)).data.data
}

export const fetchTiktokCollections = async (parentId) => {
  if (collectionsCache[parentId]) {
    return collectionsCache[parentId]
  }
  const url = `${Routes.tiktok.fetchCategories()}?parentCategory=${parentId}&levelsToLoad=1`
  const result = (await axios.get(url)).data
  collectionsCache[parentId] = result
  return result
}
